import type { Messages } from './en';

export const fr: Messages = {
  nav: {
    soon: 'Bientôt disponible',
  },
  hero: {
    eyebrow: 'Pour les coureurs qui voyagent',
    headlineLine1: 'Concentrez-vous sur la course.',
    headlineLine2: 'On s’occupe du reste.',
    lead: 'La course dure trois heures. Le week-end autour — les bons hôtels, les transferts, les repas, le vol retour — c’est trois semaines d’onglets ouverts. Le plus dur, vous l’avez déjà fait ; le reste, c’est pour nous.',
    ctaNote: 'Gratuit · sans carte',
  },
  mock: {
    from: 'Depuis',
    sortCost: 'Coût total',
    sortDate: 'Date',
    bestValue: 'Meilleur rapport',
    allIn: 'tout compris',
  },
  problem: {
    eyebrow: 'Le week-end, pas la course',
    heading: 'La course n’est jamais là où le nom le dit.',
    body1:
      'D’abord vous calculez si vous pouvez seulement vous le permettre — l’inscription, c’est le plus simple ; ce sont les vols, les hôtels et tout le reste qui décident si le voyage a lieu. Disons que oui.',
    body2:
      'Et puis le site se révèle à une heure de la ville. Donc un hôtel près du départ, un autre en ville pour récupérer, des trains que vous n’avez jamais pris, des dîners à trouver deux fois, et un vol retour qu’il faut calculer à rebours. Rien de tout ça n’est la course — et tout vous retombe dessus.',
    realCost: 'Coût réel ?',
    returnLeg: 'Trajet retour',
    crewMessage: '« on dort où ?? »',
    yourWeekend: 'Votre week-end',
    sorted: 'Réglé',
    flights: 'Vols',
    stay: 'Séjour · 2 nuits',
    race: 'Course · Beast',
    allIn: 'Tout compris',
  },
  discovery: {
    eyebrow: 'Ce que ça fait',
    heading: 'On chiffre tout le voyage, avant que vous vous engagiez.',
    lead: 'Dites-nous d’où vous partez. RaceAtlas classe chaque course selon ce qu’elle va vraiment vous coûter — de porte à porte — inscription, vol ou route, et un endroit où dormir. Des fourchettes honnêtes, un indice de confiance sur chaque chiffre, et la course la moins chère qui en vaut la peine, tout en haut.',
    feat1Kicker: 'Des chiffres honnêtes',
    feat1Heading: 'Un indice de confiance sur chaque coût',
    feat1Body:
      'Inscription, trajet, séjour — chaque ligne indique combien de données réelles l’étayent. Jamais de fausse précision.',
    feat2Kicker: 'Depuis votre porte',
    feat2Heading: 'Voiture ou avion, décidé pour vous',
    feat2Body:
      'On détermine si vous iriez en voiture ou en avion depuis chez vous — et on classe le coût total en conséquence.',
    feat3Kicker: 'Ce qui en vaut la peine, d’abord',
    feat3Heading: 'Classées, pas seulement listées',
    feat3Body:
      'La course la moins chère qui vous tente vraiment est en tête. Reclassez par date ou par distance d’un geste.',
  },
  twoJobs: {
    eyebrow: 'Gratuit ou payant',
    heading: 'Gratuit vous dit ce que ça coûte. 9,99 € vous dit quoi faire.',
    freeTag: 'Gratuit · un outil',
    freeHeading: 'Savoir ce que ça coûte',
    freeBody:
      'Cherchez, classez et comparez chaque course par son coût total réel depuis chez vous. Enregistrez votre liste. Illimité, pour toujours.',
    paidTag: '9,99 € · un service',
    paidHeading: 'Savoir quoi faire',
    paidBody:
      'Un plan de week-end qui décide pour vous — horaires du matin de course, parking et vestiaire, le café et le dîner déjà choisis, sur votre trajet et selon votre régime.',
  },
  payoff: {
    eyebrow: 'L’itinéraire à 9,99 €',
    heading: 'Comme un ami qui a déjà fait la course.',
    body1:
      'Un ami ne vous donne pas une liste de huit cafés — il vous dit où aller. Nous aussi : le café sur le chemin du départ, le dîner d’après-course qui colle à votre régime, la minute exacte pour partir et ne pas rater le vestiaire. Déjà choisi, avec la raison affichée. Changez tout d’un geste.',
    body2:
      'Il connaît le parcours, les horaires de vagues, le parking, le trajet. Ce qu’on n’apprend qu’à la dure — la deuxième fois.',
    cardDay: 'Sam 23 août · jour de course',
    leaveHotel: 'Quitter l’hôtel',
    leaveHotelSub: '15 min · parking ouvert à 07:00',
    coffee: 'Café · Bar Nuovo',
    coffeeSub: 'sur votre trajet · +6 min · ouvre à 06:30',
    raceStart: 'Départ · Beast',
    postRace: 'Repas d’après-course · Sa Tanca',
    postRaceSub: 'végétarien · +3 min au retour',
  },
  who: {
    eyebrow: 'Pour qui',
    heading: 'Conçu pour les coureurs qui voyagent pour courir.',
    lead: 'Des athlètes d’endurance qui font 5 à 15 épreuves par an — un Spartan, un Hyrox, une étape de l’UTMB et un Tough Mudder, c’est un calendrier normal. Si vous courez une fois par an, l’offre gratuite suffit largement. Si vous planifiez plusieurs week-ends à l’étranger et voulez que ça ressemble moins à du travail — c’est nous.',
  },
  pricing: {
    eyebrow: 'Tarifs',
    heading: 'Gratuit pour décider. Payez pour la partie qu’on ne trouve nulle part ailleurs.',
    freeTier: 'Gratuit',
    freeAmount: '0 €',
    freeCadence: 'pour toujours',
    freeDesc: 'Classez chaque course par son coût réel, depuis votre porte. Enregistrez une liste.',
    freeItem1: 'Recherche et classement des coûts illimités',
    freeItem2: 'Jusqu’à 3 plans enregistrés',
    freeItem3: 'Calendrier + rappels',
    perTripTier: 'Par voyage',
    perTripBadge: 'Le produit',
    perTripAmount: '9,99 €',
    perTripCadence: 'paiement unique par course',
    perTripDesc: 'Le week-end de course, planifié et décidé — comme un ami qui l’a déjà fait.',
    perTripItem1: 'Planning du matin de course + parking',
    perTripItem2: 'Café, repas et récupération, pré-choisis',
    perTripItem3: 'Partageable · remboursable pendant 7 jours',
    seasonTier: 'Pass saison',
    seasonBadge: 'Bientôt',
    seasonAmount: '45 €',
    seasonCadence: 'par an',
    seasonDesc: 'Pour 8 courses et plus par an. Toute votre saison, illimitée, au même endroit.',
    seasonItem1: 'Tous les itinéraires inclus',
    seasonItem2: 'Dépenses de saison, budget et conflits',
    seasonItem3: 'Moment de réservation (après le lancement)',
  },
  final: {
    heading: 'Concentrez-vous sur la course.',
    lead: 'On s’occupe du reste — ce que ça coûte, où vous dormez, comment vous y allez, quoi faire en arrivant. Gratuit pour commencer, sans carte.',
  },
  footer: {
    privacy: 'Confidentialité',
    terms: 'Conditions',
    contact: 'Contact',
  },
  seo: {
    title: 'Race Atlas — Concentrez-vous sur la course, on s’occupe du reste',
    description:
      'Race Atlas planifie vos week-ends de course de bout en bout — ce qu’ils coûtent vraiment, où dormir, comment y aller et quoi faire en arrivant. Concentrez-vous sur la course ; on s’occupe du plan.',
  },
};
